<template>
    <ac-modal :title="'Message Center'" ref="modalRef">
        <slot>
            <div v-if="paginatedMessages.length==0">
                No messages at this time.
            </div>
            <div v-else>
                <h5>Your Messages</h5>
            </div>
            <div style="max-height: 390px; overflow: auto;" v-for="message in paginatedMessages">
                <message :message="message"></message>
            </div>
            <div v-if="thereAreMoreMessages">
                <a class="cursor-pointer" @click.prevent="showMore">
                    <div class="divider"></div>
                    <h6 class="text-center">SHOW MORE</h6>
                </a>
            </div>

            <hr>

            <!-- Physicians don't have any 'children' -->
            <template v-if="!isPhysician">
                <div v-if="childrenMessages.length==0">
                    No messages for your providers at this time.
                </div>
                <div v-else>
                    <h5>Messages For Your Providers</h5>
                </div>
                <div style="max-height: 390px; overflow: auto;" v-for="childMessage in childrenMessages">
                    <message :message="childMessage" :store-module="'childrenMessageCenter'">
                        <slot name="message-header">
                            {{ childMessage.name }}
                        </slot>
                    </message>
                </div>
                <div v-if="thereAreMoreChildrenMessages">
                    <a class="cursor-pointer" @click.prevent="showMoreChildrenMessages">
                        <div class="divider"></div>
                        <h6 class="text-center">SHOW MORE</h6>
                    </a>
                </div>
            </template>

        </slot>
    </ac-modal>
</template>

<script>
    import Message from "../Message.vue";
    import {common} from "../../../global/common.js";
    import {mapGetters} from 'vuex';
    import _ from 'lodash';

    export default {
        name: "ProviderMessageCenterModal",
        components: {Message},
        data() {
            return {
                entityId: 0,
                entityTypeId: 0
            };
        },
        computed: {
            ...mapGetters(['paginatedMessages', 'messageCount']),
            ...mapGetters({
                childrenMessages: 'childrenMessageCenter/paginatedMessages',
                childrenMessagesCount: 'childrenMessageCenter/messageCount'
            }),
            //Same button loads messages for both parent and children
            thereAreMoreMessages() {
                return this.messageCount > 5 && this.paginatedMessages.length < this.messageCount;
            },
            thereAreMoreChildrenMessages() {
                return this.childrenMessagesCount > 5 && this.childrenMessages.length < this.childrenMessagesCount;
            },
            isPhysician() {
                return this.entityTypeId === common.ENTITY_TYPE.PHYSICIAN;
            }
        },
        methods: {
            async showModal({entityId, entityTypeId}) {
                //console.log("Opening message center, entityId:", entityId, ' entity type:', entityTypeId);
                this.entityId = entityId;
                this.entityTypeId = entityTypeId;
                await this.$store.dispatch('SET_ENTITY_DATA', {entityId, entityTypeId});
                await this.$store.dispatch('childrenMessageCenter/SET_ENTITY_DATA', {entityId, entityTypeId});
                await this.$store.dispatch('LOAD_MESSAGES');
                await this.$store.dispatch('childrenMessageCenter/LOAD_MESSAGES');
                this.$refs.modalRef.open();
            },
            showMore() {
                this.$store.dispatch('LOAD_MORE_MESSAGES');
            },
            showMoreChildrenMessages() {
                this.$store.dispatch('childrenMessageCenter/LOAD_MORE_MESSAGES');
            }
        }
    }
</script>

<style scoped>

</style>